import { render, staticRenderFns } from "./PaymentManager.vue?vue&type=template&id=6bcc09f8"
import script from "./PaymentManager.vue?vue&type=script&lang=js"
export * from "./PaymentManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports